import { Component, type ErrorInfo, type ReactNode } from "react";
import styles from "./errorBoundary.module.scss";

interface Props {
  children: ReactNode;
  /** Rendered instead of the full-page error; `null` quietly drops a broken card. */
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) return this.props.fallback;
      return (
        <div className={styles.errorWrap}>
          <h2>Something went wrong</h2>
          <pre className={styles.errorMessage}>
            {this.state.error?.message}
          </pre>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
